"use client";

import { ArrowRightEndOnRectangleIcon, ArrowTopRightOnSquareIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Button } from "@ubud-ui/react-ui-kit";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { PropsWithChildren } from "react";

export function RegistrationGuard({ children }: PropsWithChildren) {
  const config = useClientConfig();
  const nacoUser = config?.nacoUser;

  const pathname = usePathname();
  const searchParams = useSearchParams()?.toString();

  const callbackUrl = encodeURIComponent(pathname + (searchParams ? "?" + searchParams : ""));

  if (!nacoUser) {
    return (
      <div className="p-6 md:p-10">
        <h1 className="text-xl font-bold">Masuk ke SIAPkerja</h1>
        <p className="text-sm font-normal text-gray-500 mt-2">Masuk ke akun SIAPkerja Anda untuk melanjutkan pendaftaran.</p>
        <div className="bg-gray-100 rounded-xl flex items-start p-4 gap-3 mt-4">
          <div className="size-8 min-w-8 rounded-lg bg-gray-300 inline-flex items-center justify-center text-center">
            <InformationCircleIcon className="size-5 min-w-5" />
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-sm">Apa itu SIAPkerja?</h4>
            <p className="text-xs text-gray-500 font-normal mt-1">
              Platform resmi Kemnaker RI untuk manajemen tenaga kerja, termasuk pendaftaran dan pengelolaan program magang nasional.
            </p>
          </div>
        </div>

        <div className="flex items-center flex-col space-y-5 justify-center text-center mt-6">
          <div className="size-16 min-w-16 inline-flex items-center justify-center text-center bg-slate-200 rounded-2xl">
            <ArrowRightEndOnRectangleIcon className="size-10 min-w-10" />
          </div>
          <p className="text-gray-500 text-sm">
            Klik tombol di bawah untuk masuk ke akun SIAPkerja. Setelah berhasil login, kembali ke halaman ini untuk melanjutkan.
          </p>
          <div>
            <Button variant="default" className="font-bold text-sm" asChild>
              <Link href={"/api/naco/login?redirect_url=" + callbackUrl} prefetch={false}>
                <span>Masuk ke SIAPkerja</span>
                <ArrowTopRightOnSquareIcon className="size-4 min-w-4" />
              </Link>
            </Button>
          </div>
          <hr className="border-gray-200 h-px w-full" />
          <div className="text-gray-500 text-sm">
            Belum memiliki akun?{" "}
            <Button variant="link" className="font-bold text-sm w-auto h-auto m-0 p-0">
              <a href="https://account.kemnaker.go.id/register" target="_blank">
                Daftar akun SIAPkerja sekarang.
              </a>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return children;
}
